import { Bar } from "react-chartjs-2";
import { 
    Chart as ChartJS, 
    Tooltip, 
    Legend, 
    CategoryScale, 
    LinearScale,
    BarElement } from "chart.js";

ChartJS.register(Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const BarChart = (props) => {
    const options = {};
    return (
        <>
            {props.data && <Bar options={options} data={props.data} />}
        </>
    )
}

export default BarChart;